/**
 * @flow
 * @relayHash a1dd696a9c6fa52078700a235b9efcb1
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowsOrderNormalizeInput = {
  temp: string
};
export type TVShowsOrderNormalizeMutationVariables = {|
  input: TVShowsOrderNormalizeInput
|};
export type TVShowsOrderNormalizeMutationResponse = {|
  +TVShowsOrderNormalize: ?{|
    +tvshows: ?$ReadOnlyArray<?{|
      +id: string,
      +title: ?string,
      +order: number,
    |}>
  |}
|};
export type TVShowsOrderNormalizeMutation = {|
  variables: TVShowsOrderNormalizeMutationVariables,
  response: TVShowsOrderNormalizeMutationResponse,
|};
*/


/*
mutation TVShowsOrderNormalizeMutation(
  $input: TVShowsOrderNormalizeInput!
) {
  TVShowsOrderNormalize(input: $input) {
    tvshows {
      id
      title
      order
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowsOrderNormalizeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowsOrderNormalize",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowsOrderNormalizeInput!"
      }
    ],
    "concreteType": "TVShowsOrderNormalizePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tvshows",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShow",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "order",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowsOrderNormalizeMutation",
  "id": null,
  "text": "mutation TVShowsOrderNormalizeMutation(\n  $input: TVShowsOrderNormalizeInput!\n) {\n  TVShowsOrderNormalize(input: $input) {\n    tvshows {\n      id\n      title\n      order\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowsOrderNormalizeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowsOrderNormalizeMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '72ba971d353a977aef209819c4ff1a37';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowsOrderNormalizeMutation.graphql.js